import React from 'react';

const Underline = () => {
    return (
        <div>
            <div style={{width: 120, height: 4, borderRadius: 2, background: 'linear-gradient(101.79deg, #2CB5C8 0%, #63D1DF 100%)'}}>

            </div>
        </div>
    )
}

export default Underline;